/**
 * Created by slava on 5/3/19
 */

// eslint-disable-next-line no-var
var cleverapps = {
    config: document.ccConfig || cc.game.config
};

cleverapps.config.availables = cleverapps.config.availables || {};

if (typeof engine === "undefined") {
    engine = "cocos2d";
}
